import React from 'react';

const HeroSection = ({ aoClicarBotao }) => {
  return (
    // 1. Mudamos para bg-[#F9F7F2] e removemos o excesso de camadas pretas
    <section className="relative min-h-screen flex items-center pt-20 bg-[#F9F7F2] overflow-hidden">
      <div className="container mx-auto px-4 lg:px-8 relative z-10">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* LADO ESQUERDO: Conteúdo de Texto */}
          <div className="text-center md:text-left space-y-6">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-serif font-extrabold leading-tight text-slate-900">
              Venda Mais. <span className="text-elion-gold">Ganhe Mais.</span>
              <br className="hidden md:inline" />
              <span className="block">Construa Seu Legado.</span>
            </h1>

            <p className="text-lg md:text-xl text-slate-600 max-w-2xl">
              O sonho da sua própria imobiliária começa aqui.
            </p>

            <button
              onClick={aoClicarBotao}
              className="mt-4 bg-elion-gold text-white font-semibold px-8 py-4 rounded-full shadow-lg hover:bg-yellow-500 transition-all duration-300 hover:scale-105"
            >
              Liberar Meu Acesso
            </button>
          </div>

          {/* LADO DIREITO: Imagem (Estilo Ricardo Martins) */}
          <div className="relative flex justify-center lg:justify-end">
            <div className="relative">
              {/* Detalhe decorativo atrás da foto */}
              <div className="absolute -top-4 -right-4 w-full h-full border-2 border-elion-gold/20 rounded-2xl" />

              <img
                src="/imagens/hero.jpg.jpeg"
                alt="Profissional de sucesso"
                className="relative z-10 w-full max-w-md lg:max-w-lg h-[500px] object-cover rounded-2xl shadow-2xl"
              />
            </div>
          </div>
        </div>
      </div>

      {/* Removido o gradiente preto que cobria tudo */}
    </section>
  );
};

export default HeroSection;
